module.exports = __webpack_public_path__ + "static/media/aus_logo.8a7c2433.svg";